import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { CustomPopover, Scrollbars } from '@meitu/saas-ui';
import { useEditorStateChange } from '@meitu/saas-editor-ui/es/hooks/use-editor-state-change';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import IconFont from '@meitu/xdesign-icon-font';
import {
    getQrCodeImage,
    qrCodeCoverList,
} from '@/editor/collapse/views/shortcut-collapse/panels/qrcode-sub-panel/config';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const StyleFeature: React.FC<{
    id: string;
    fill: string;
    stroke: string;
}> = React.memo(({ id, fill, stroke }) => {
    const { $t } = useLocaleStore();
    const [showStyle, setShowStyle] = useState<boolean>(false);
    const curColorKey = `${fill}${stroke}`;
    const currentPreview = qrCodeCoverList.find((item) => item.key === curColorKey);
    const globalWidgetRef = useGlobalWidget(editor, false);

    useEditorStateChange(editor, () => {
        setShowStyle(false);
    });

    useEffect(() => {
        globalWidgetRef.current = showStyle;
    }, [showStyle]);

    return (
        <div className="c-qrcode-panel__style-wrap">
            <div
                className="c-qrcode-panel__style"
                onClick={() => {
                    setShowStyle(true);
                }}
            >
                <div className="c-qrcode-panel__style-preview">
                    {currentPreview ? (
                        <>{getQrCodeImage(currentPreview.index, 48, 48)}</>
                    ) : (
                        <IconFont fontSize={26} name="PlusBold" />
                    )}
                </div>
                <div className="c-qrcode-panel__style-text">{$t((v) => v.panel.qrCodePanel.selectStyle)}</div>
            </div>
            {showStyle ? (
                <CustomPopover
                    content={() => (
                        <div className="c-qrcode-panel__style-panel">
                            <Scrollbars autoHide={true}>
                                <div className="c-qrcode-panel__style-panel-content">
                                    {qrCodeCoverList.map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => {
                                                    editor.qrCodeLayer.updateStyle(id, item.colors, {
                                                        writeHistory: true,
                                                        oldStyle: {
                                                            fill,
                                                            stroke,
                                                        },
                                                    });
                                                }}
                                                className={classnames('c-qrcode-panel__style-panel-content-item', {
                                                    active: curColorKey === item.key,
                                                })}
                                            >
                                                <div className="c-qrcode-panel__style-panel-content-item-wrap">
                                                    {getQrCodeImage(index, 58, 58)}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Scrollbars>
                        </div>
                    )}
                    setVisible={setShowStyle}
                    style={{
                        padding: 0,
                        height: 278,
                        width: '100%',
                    }}
                    excludeClass={['custom-popover']}
                />
            ) : null}
        </div>
    );
});
